<template>
    <div class="load-mask-parent">
        <component-title
            :config="config">
        </component-title>
        <div :class="loadMask"></div>
        <component
            :is="chartComponent"
            :chartData="chartData"
            :options="options"
            :showLegend="showLegend"
            :showGrid="showGrid"
            :dashedLines="dashedLines"
            :height="120"
            :componentIndex="componentIndex"
        />
        <div class="chart-options">
            <label>
                <input type="checkbox" v-model="showLegend" v-on:click="toggleShowLegend"> {{ t('Show legend') }}
            </label>
            <label>
                <input type="checkbox" v-model="showGrid" v-on:click="toggleShowGrid"> {{ t('Show grid') }}
            </label>
            <label>
                <input type="checkbox" v-model="dashedLines" v-on:click="toggleDashedLines"> {{ t('Dashed lines') }}
            </label>
        </div>
    </div>
</template>

<script>

import { createChart } from './chart/ChartFactory'
import ComponentTitle from "@/components/ComponentTitle.vue";

export default {
    components: {ComponentTitle},
    props: {
        config: {
            Type: Object,
            default: function () {
                return {
                    type: null,
                    showLegend: false,
                    index: null,
                    emitEvents: {},
                    visible: true,
                    showGrid: false,
                    dashedLines: false,
                }
            }
        },
        eventBus: {
            Type: Object,
        },
        routeParams: {
            Type: Object
        },
        moduleName: {
            Type: String,
            require: true,
        },
    },
    computed: {
        chartComponent() {
            if (null === this.type) {
                return;
            }

            return createChart(this.type || 'line')
        }
    },
    data() {
        let _this = this;

        return {
            chartData: {
                items: [], labels: [],
            },
            state: {},
            type: null,
            showLegend: false,
            showGrid: false,
            dashedLines: false,
            componentIndex: null,
            loadMask: '',
            yAxisTicks: {
                min: 0,
                max: 0,
                step: 0,
            },
            options: {
                tension: 0,
                lineJoin: 'bevel',
                responsive: true,
                legend: {
                    display: false
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false,
                        },
                        gridLines: {
                            display: false
                        },
                    }]
                },
                pan: {
                    enabled: true,
                    mode: 'y'
                },
                zoom: {
                    enabled: true,
                    mode: 'y',
                }
            }
        }
    },
    inject: ['eventManager'],
    mounted () {
        this.init();
        this.setState(this.routeParams);
        this.mountEvents();
        this.eventManager.emitEvents(this.config.emitEvents['mounted'] || [], []);
    },
    unmountEvents() {
        this.eventManager.unbindEvents(this.defaultBindEvents());
    },
    methods: {
        init() {
            this.componentIndex = this.config.index;
            this.type = this.config.type;
            this.showLegend = this.config.showLegend;
            this.showGrid = this.config.showGrid;
            this.dashedLines = this.config.dashedLines;
            this.$set(this.options, 'legend', {display: this.showLegend});
            this.$set(this.options.scales.yAxes[0], 'gridLines', {display: this.showGrid});
        },
        setState(data) {
            this.state.value = data;
        },
        addLoadMask() {
            this.loadMask = 'lmask';
        },
        removeLoadMask() {
            this.loadMask = '';
        },
        mountEvents() {
            this.eventManager.bindEvents(this.defaultBindEvents(), this);
        },
        defaultBindEvents() {
            return [{
                name: 'load',
                componentIndex: this.componentIndex,
            }];
        },
        async load(eventData, data) {
            this.addLoadMask();
            let response = await this.fetchData(data);
            this.setChartData(response.data.items, response.data.labels);
            this.removeLoadMask();
        },
        async fetchData(params) {
            this.setState(params);
            const url = this.config['loadUrl'];

            return await this.$http.get(url, {params: params});
        },
        toggleShowLegend() {
            this.showLegend = !this.showLegend;
        },
        toggleShowGrid() {
            this.showGrid = !this.showGrid;
        },
        toggleDashedLines() {
            this.dashedLines = !this.dashedLines;
        },
        setChartData(items, labels) {
            this.chartData = {labels: labels, datasets: items };
        }
    }
}
</script>

<style lang="scss" scoped>
    .chart-options {
        padding: 20px 30px;
        text-align: center;

        label {
            margin-right: 20px;
            cursor: pointer;

            input[type="checkbox"] {
                margin-right: 5px;
            }

            span {
                padding-right: 8px;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// DynamicChartComponent.vue?1f5aa110